// @flow

import * as types from '../actionTypes';
import { reviewStar } from '../schemata';
import genericNestedReducer, {
  genericNestedSelectorSet,
  useGenericNested,
} from './genericNested';
// import genericReducer, { genericSelectorSet, useGeneric } from './generic'
import type { reviewStarType } from '../../types';

const reviewStars = genericNestedReducer(types.GET_REVIEWSTAR_ASYNC);

export default reviewStars;

export const selectReviewStars = genericNestedSelectorSet<reviewStarType>(
  reviewStar,
  state => state.reviews,
);

export const useReviewStars = useGenericNested<reviewStarType>(
  reviewStar,
  state => state.reviewStars,
  state => state.reviews,
);
